{
  "labels": {
    "paste": "วาง",
    "pasteAsPlaintext": "วางโดยไม่มีการจัดรูปแบบ",
    "pasteCharts": "วางแผนภูมิ",
    "selectAll": "เลือกทั้งหมด",
    "multiSelect": "",
    "moveCanvas": "",
    "cut": "ตัด",
    "copy": "คัดลอก",
    "copyAsPng": "คัดลองไปยังคลิปบอร์ดเป็น PNG",
    "copyAsSvg": "คัดลองไปยังคลิปบอร์ดเป็น SVG",
    "copyText": "คัดลองไปยังคลิปบอร์ดเป็นข้อความ",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "นำขึ้นข้างบน",
    "sendToBack": "ย้ายไปข้างล่าง",
    "bringToFront": "นำขึ้นข้างหน้า",
    "sendBackward": "ย้ายไปข้างหลัง",
    "delete": "ลบ",
    "copyStyles": "คัดลอกรูปแบบ",
    "pasteStyles": "วางรูปแบบ",
    "stroke": "เส้นขอบ",
    "background": "พื้นหลัง",
    "fill": "เติมสี",
    "strokeWidth": "น้ำหนักเส้นขอบ",
    "strokeStyle": "รูปแบบเส้น",
    "strokeStyle_solid": "เส้นทึบ",
    "strokeStyle_dashed": "เส้นประ",
    "strokeStyle_dotted": "จุด",
    "sloppiness": "ความเลอะเทอะ",
    "opacity": "ความทึบแสง",
    "textAlign": "จัดข้อความ",
    "edges": "ขอบ",
    "sharp": "",
    "round": "",
    "arrowheads": "หัวลูกศร",
    "arrowhead_none": "ไม่มี",
    "arrowhead_arrow": "ลูกศร",
    "arrowhead_bar": "แถบ",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "สามเหลี่ยม",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "ขนาดตัวอักษร",
    "fontFamily": "แบบตัวอักษร",
    "addWatermark": "เพิ่มลายน้ำ \"สร้างด้วย Excalidraw\"",
    "handDrawn": "ลายมือ",
    "normal": "ปกติ",
    "code": "โค้ด",
    "small": "เล็ก",
    "medium": "กลาง",
    "large": "ใหญ่",
    "veryLarge": "ใหญ่มาก",
    "solid": "",
    "hachure": "",
    "zigzag": "",
    "crossHatch": "",
    "thin": "บาง",
    "bold": "หนา",
    "left": "ซ้าย",
    "center": "กลาง",
    "right": "ขวา",
    "extraBold": "หนาพิเศษ",
    "architect": "",
    "artist": "ศิลปิน",
    "cartoonist": "",
    "fileTitle": "ชื่อไฟล์",
    "colorPicker": "เลือกสีที่กำหนดเอง",
    "canvasColors": "",
    "canvasBackground": "",
    "drawingCanvas": "",
    "layers": "",
    "actions": "การกระทำ",
    "language": "ภาษา",
    "liveCollaboration": "",
    "duplicateSelection": "ทำสำเนา",
    "untitled": "ไม่มีชื่อ",
    "name": "ชื่อ",
    "yourName": "ชื่อของคุณ",
    "madeWithExcalidraw": "",
    "group": "จัดกลุ่ม",
    "ungroup": "ยกเลิกการจัดกลุ่ม",
    "collaborators": "",
    "showGrid": "แสดงเส้นตาราง",
    "addToLibrary": "เพิ่มไปในคลัง",
    "removeFromLibrary": "นำออกจากคลัง",
    "libraryLoadingMessage": "กำลังโหลดคลัง...",
    "libraries": "",
    "loadingScene": "กำลังโหลดฉาก",
    "align": "จัดตำแหน่ง",
    "alignTop": "จัดชิดด้านบน",
    "alignBottom": "จัดชิดด้านล่าง",
    "alignLeft": "จัดชิดซ้าย",
    "alignRight": "จัดชิดขวา",
    "centerVertically": "กึ่งกลางแนวตั้ง",
    "centerHorizontally": "กึ่งกลางแนวนอน",
    "distributeHorizontally": "กระจายแนวนอน",
    "distributeVertically": "กระจายแนวตั้ง",
    "flipHorizontal": "พลิกแนวนอน",
    "flipVertical": "พลิกแนวตั้ง",
    "viewMode": "โหมดมุมมอง",
    "share": "แชร์",
    "showStroke": "",
    "showBackground": "",
    "toggleTheme": "สลับธีม",
    "personalLib": "คลังของฉัน",
    "excalidrawLib": "คลังของ Excalidraw",
    "decreaseFontSize": "ลดขนาดตัวอักษร",
    "increaseFontSize": "เพิ่มขนาดตัวอักษร",
    "unbindText": "ยกเลิกการผูกติด",
    "bindText": "",
    "createContainerFromText": "",
    "link": {
      "edit": "แก้ไขลิงก์",
      "editEmbed": "แก้ไขลิงค์และการฝัง",
      "create": "สร้างลิงค์",
      "createEmbed": "สร้างลิงค์และการฝัง",
      "label": "ลิงค์",
      "labelEmbed": "ลิงค์และการฝัง",
      "empty": "ไม่ได้ใส่ลิงค์"
    },
    "lineEditor": {
      "edit": "แก้ไขเส้น",
      "exit": ""
    },
    "elementLock": {
      "lock": "ล็อก",
      "unlock": "ปลดล็อก",
      "lockAll": "ล็อกทั้งหมด",
      "unlockAll": "ปลดล็อกทั้งหมด"
    },
    "statusPublished": "เผยแพร่",
    "sidebarLock": "",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "ยังไม่มีรายการที่เพิ่มเข้าไปได้",
    "hint_emptyLibrary": "",
    "hint_emptyPrivateLibrary": ""
  },
  "buttons": {
    "clearReset": "รีเซ็ทผืนผ้าใบ",
    "exportJSON": "ส่งออกไปยังไฟล์",
    "exportImage": "ส่งออกเป็นรูปภาพ",
    "export": "บันทึกไปยัง",
    "copyToClipboard": "คัดลอกไปยังคลิปบอร์ด",
    "save": "บันทึกเป็นไฟล์ปัจจุบัน",
    "saveAs": "บันทึกเป็น",
    "load": "เปิด",
    "getShareableLink": "สร้างลิงค์ที่แชร์ได้",
    "close": "ปิด",
    "selectLanguage": "เลือกภาษา",
    "scrollBackToContent": "เลื่อนกลับไปด้านบน",
    "zoomIn": "ซูมเข้า",
    "zoomOut": "ซูมออก",
    "resetZoom": "รีเซ็ตการซูม",
    "menu": "เมนู",
    "done": "เสร็จสิ้น",
    "edit": "แก้ไข",
    "undo": "เลิกทำ",
    "redo": "ทำซ้ำ",
    "resetLibrary": "รีเซ็ตคลัง",
    "createNewRoom": "สร้างห้องใหม่",
    "fullScreen": "เต็มหน้าจอ",
    "darkMode": "โหมดกลางคืน",
    "lightMode": "โหมดกลางวัน",
    "zenMode": "โหมด Zen",
    "objectsSnapMode": "",
    "exitZenMode": "ออกจากโหมด Zen",
    "cancel": "ยกเลิก",
    "clear": "เคลียร์",
    "remove": "ลบ",
    "embed": "สลับการฝัง",
    "publishLibrary": "เผยแพร่",
    "submit": "ตกลง",
    "confirm": "ยืนยัน",
    "embeddableInteractionButton": "คลิกเพื่อปฏิสัมพันธ์"
  },
  "alerts": {
    "clearReset": "",
    "couldNotCreateShareableLink": "ไม่สามารถสร้างลิงค์ได้",
    "couldNotCreateShareableLinkTooBig": "",
    "couldNotLoadInvalidFile": "ไม่สามารถโหลดไฟล์ที่ผิดพลาดได้",
    "importBackendFailed": "เกิดข้อผิดพลาดจากการนำเข้าจากระบบหลังบ้าน",
    "cannotExportEmptyCanvas": "ไม่สามารถนำออกจากผืนผ้าใบที่ว่างเปล่าได้",
    "couldNotCopyToClipboard": "ไม่สามารถคัดลอกไปยังคลิปบอร์ดได้",
    "decryptFailed": "ไม่สามารถถอดรหัสข้อมูลได้",
    "uploadedSecurly": "การอัพโหลดได้ถูกเข้ารหัสแบบ end-to-end หมายความว่าเซิร์ฟเวอร์ของ Excalidraw และบุคคลอื่นไม่สามารถอ่านข้อมูลได้",
    "loadSceneOverridePrompt": "",
    "collabStopOverridePrompt": "",
    "errorAddingToLibrary": "ไม่สามารถเพิ่มรายการเข้าไปในคลังได้",
    "errorRemovingFromLibrary": "ไม่สามารถลบรายการนี้ออกจากคลังได้",
    "confirmAddLibrary": "",
    "imageDoesNotContainScene": "",
    "cannotRestoreFromImage": "",
    "invalidSceneUrl": "",
    "resetLibrary": "",
    "removeItemsFromsLibrary": "",
    "invalidEncryptionKey": "",
    "collabOfflineWarning": ""
  },
  "errors": {
    "unsupportedFileType": "ไม่รองรับชนิดของไฟล์นี้",
    "imageInsertError": "ไม่สามารถเพิ่มรูปภาพได้ ลองอีกครั้งในภายหลัง",
    "fileTooBig": "",
    "svgImageInsertError": "",
    "failedToFetchImage": "",
    "invalidSVGString": "ไฟล์ SVG ผิดพลาด",
    "cannotResolveCollabServer": "ไม่สามารถเชื่อต่อกับ collab เซิร์ฟเวอร์ได้ โปรดลองโหลดหน้านี้ใหม่และลองอีกครั้ง",
    "importLibraryError": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "การเพิ่มองค์ประกอบที่ฝังยังไม่สามารถเพิ่มเข้าไปในไลบลารีได้",
      "iframe": "",
      "image": "การสนับสนุนสำหรับเพิ่มรูปภาพลงในไลบลารีจะมาในเร็ว ๆ นี้"
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "",
    "image": "",
    "rectangle": "สี่เหลี่ยมผืนผ้า",
    "diamond": "",
    "ellipse": "วงรี",
    "arrow": "ลูกศร",
    "line": "",
    "freedraw": "",
    "text": "ข้อความ",
    "library": "คลัง",
    "lock": "",
    "penMode": "",
    "link": "",
    "eraser": "ยางลบ",
    "frame": "",
    "magicframe": "",
    "embeddable": "ฝังเว็บ",
    "laser": "",
    "hand": "",
    "extraTools": "เครื่องมืออื่นๆ",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "",
    "selectedShapeActions": "",
    "shapes": "รูปร่าง"
  },
  "hints": {
    "canvasPanning": "",
    "linearElement": "",
    "freeDraw": "",
    "text": "",
    "embeddable": "คลิกและลากเพื่อสร้างการฝังสำหรับเว็บไซต์",
    "text_selected": "คลิกสองครั้งหรือกด ENTER เพื่อแก้ไขข้อความ",
    "text_editing": "กดปุ่ม Esc หรือกด Ctrl, Cmd + Enter เพื่อเสร็จการแก้ไข",
    "linearElementMulti": "คลิกที่จุดสุดท้ายหรือกด Escape หรือ Enter เพื่อเสร็จสิ้น",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_pointSelected": "กดปุ่ม Delete เพื่อลบจุด\nกด Ctrl หรือ Cmd + D เพื่อทำซ้ำหรือลากเพื่อเคลื่อนย้าย",
    "lineEditor_nothingSelected": "",
    "placeImage": "",
    "publishLibrary": "",
    "bindTextToElement": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "",
    "canvasTooBig": "",
    "canvasTooBigTip": ""
  },
  "errorSplash": {
    "headingMain": "<button>กำลังรีโหลดหน้า</button>",
    "clearCanvasMessage": "ถ้าโหลดไม่ได้ ให้ลอง <button>เคลียร์ผืนผ้าใบ</button>",
    "clearCanvasCaveat": "",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "เริ่มเซสชัน",
    "button_stopSession": "หยุดเซสชัน",
    "desc_inProgressIntro": "",
    "desc_shareLink": "",
    "desc_exitSession": "",
    "shareTitle": ""
  },
  "errorDialog": {
    "title": ""
  },
  "exportDialog": {
    "disk_title": "",
    "disk_details": "",
    "disk_button": "",
    "link_title": "",
    "link_details": "",
    "link_button": "",
    "excalidrawplus_description": "",
    "excalidrawplus_button": "",
    "excalidrawplus_exportError": "ไม่สามารถส่งออกไปที่ Excalidraw+ ได้ในขณะนี้"
  },
  "helpDialog": {
    "blog": "อ่านบล็อกของพวกเรา",
    "click": "คลิก",
    "deepSelect": "",
    "deepBoxSelect": "",
    "curvedArrow": "",
    "curvedLine": "",
    "documentation": "",
    "doubleClick": "ดับเบิลคลิก",
    "drag": "ลาก",
    "editor": "",
    "editLineArrowPoints": "",
    "editText": "แก้ไขข้อความ / เพิ่มข้อความ",
    "github": "",
    "howto": "",
    "or": "",
    "preventBinding": "",
    "tools": "",
    "shortcuts": "",
    "textFinish": "",
    "textNewLine": "",
    "title": "ช่วยเหลือ",
    "view": "ดู",
    "zoomToFit": "",
    "zoomToSelection": "",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": "ย้ายหน้าไปด้าน ซ้าย/ขวา"
  },
  "clearCanvasDialog": {
    "title": ""
  },
  "publishDialog": {
    "title": "",
    "itemName": "",
    "authorName": "ชื่อเจ้าของ",
    "githubUsername": "ชื่อผู้ใช้ GitHub",
    "twitterUsername": "ชื่อผู้ใช้ Twitter",
    "libraryName": "",
    "libraryDesc": "",
    "website": "",
    "placeholder": {
      "authorName": "",
      "libraryName": "",
      "libraryDesc": "",
      "githubHandle": "",
      "twitterHandle": "",
      "website": ""
    },
    "errors": {
      "required": "",
      "website": ""
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "",
    "atleastOneLibItem": "",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "",
    "content": ""
  },
  "confirmDialog": {
    "resetLibrary": "",
    "removeItemsFromLib": ""
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "โหมดกลางคืน",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "ส่งออกไปเป็น SVG",
      "exportToSvg": "ส่งออกไปเป็น SVG",
      "copyPngToClipboard": "คัดลอก PNG ไปยังคลิปบอร์ด"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "คัดลอกไปยังคลิปบอร์ด"
    }
  },
  "encrypted": {
    "tooltip": "",
    "link": ""
  },
  "stats": {
    "angle": "",
    "element": "",
    "elements": "",
    "height": "",
    "scene": "",
    "selected": "",
    "storage": "",
    "title": "",
    "total": "",
    "version": "",
    "versionCopy": "",
    "versionNotAvailable": "",
    "width": ""
  },
  "toast": {
    "addedToLibrary": "",
    "copyStyles": "",
    "copyToClipboard": "",
    "copyToClipboardAsPng": "",
    "fileSaved": "",
    "fileSavedToFilename": "",
    "canvas": "",
    "selection": "",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "ฟ้าน้ำทะเล",
    "green": "เขียว",
    "yellow": "เหลือง",
    "orange": "ส้ม",
    "bronze": "ทองแดง"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
